export function SetCtxFont(ctx, fontString) {
  if (fontString != ctx.font) ctx.font = fontString;
}
